import { render } from "./CustomerOrdersTest.vue?vue&type=template&id=0bce1fca&scoped=true"
import script from "./CustomerOrdersTest.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersTest.vue?vue&type=script&lang=js"

import "./CustomerOrdersTest.vue?vue&type=style&index=0&id=0bce1fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce1fca"]])

export default __exports__